var exports = {
  "wx": "MobileSettingsView.module__header___aTVITl",
  "VW": "MobileSettingsView.module__headerContent___aTVITl",
  "pS": "MobileSettingsView.module__headerContentRelative___aTVITl",
  "lt": "MobileSettingsView.module__bannerTextContainer___aTVITl",
  "_M": "MobileSettingsView.module__bannerText___aTVITl",
  "BM": "MobileSettingsView.module__bannerTextWhite___aTVITl",
  "yp": "MobileSettingsView.module__bannerTextPrimary___aTVITl",
  "gG": "MobileSettingsView.module__bannerActions___aTVITl",
  "Gv": "MobileSettingsView.module__backButton___aTVITl",
  "qd": "MobileSettingsView.module__headerTitle___aTVITl",
  "aF": "MobileSettingsView.module__headerActionSlot___aTVITl",
  "BJ": "MobileSettingsView.module__icon5___aTVITl",
  "gs": "MobileSettingsView.module__scrollerContainer___aTVITl",
  "Wy": "MobileSettingsView.module__categorySection___aTVITl",
  "p8": "MobileSettingsView.module__categoryTitle___aTVITl",
  "jv": "MobileSettingsView.module__categoryList___aTVITl",
  "tl": "MobileSettingsView.module__settingsItem___aTVITl",
  "ZF": "MobileSettingsView.module__settingsItemPressed___aTVITl",
  "QS": "MobileSettingsView.module__settingsItemIcon___aTVITl",
  "ec": "MobileSettingsView.module__settingsItemContent___aTVITl",
  "CR": "MobileSettingsView.module__settingsItemLabelContainer___aTVITl",
  "yU": "MobileSettingsView.module__settingsItemSpinner___aTVITl",
  "N5": "MobileSettingsView.module__settingsItemLabel___aTVITl",
  "o9": "MobileSettingsView.module__settingsItemArrow___aTVITl",
  "x": "MobileSettingsView.module__settingsItemExternalIcon___aTVITl",
  "yF": "MobileSettingsView.module__divider___aTVITl",
  "lk": "MobileSettingsView.module__clientInfoContainer___aTVITl",
  "rl": "MobileSettingsView.module__sourceCodeLink___aTVITl",
  "hQ": "MobileSettingsView.module__contentContainer___aTVITl",
  "Yd": "MobileSettingsView.module__scrollerFlex___aTVITl",
  "rZ": "MobileSettingsView.module__profileSection___aTVITl",
};

module.exports = exports;
